import _ from 'underscore';
import Backbone from 'backbone';

export default Backbone.Model.extend({
    defaults: {
        showWindow: false,
        securityLevelClass: '',
        securityLevel: 0,
        minQuantity: false,
        minChars: false,
        minNumber: false,
        classPrefix: 'level-',
        passwordLength: {
            minimum: 6,
            better: 8,
            medium: 8,
            safety: 12
        },
        minPasswordLength: 6
    },

    initialize: function () {
        this.set('securityLevelClass', this.get('classPrefix') + this.get('securityLevel'));
    },

    /**
     * Check password quality with rules and update model
     *
     * @param {String} string
     */
    check: function (string) {
        /**
        * 1 - Min. 6 characters entered
        * 2 - At least 1 number included
        * 3 - At least 1 letter included
        */
        var securityLevel = this.getSecurityLevel(string, this.get('passwordLength'));
        var securityLevelClass = this.get('classPrefix') + securityLevel;

        this.set('securityLevel', securityLevel);
        this.set('minQuantity', (string.length >= this.get('minPasswordLength')));
        this.set('minChars', (/[a-z]/i.test(string)));
        this.set('minNumber', (/[0-9]/.test(string)));
        this.set('securityLevelClass', securityLevelClass);
    },

    /**
     * Get security level of a password
     *
     * @param {String} string
     * @param {Number} passwordLength
     * @return (Number) security level, one of: [ 1=bad, 2=sufficient, 3=good, 4=excellent ]
     */
    getSecurityLevel: function (string, passwordLength) {
        var level = 0;

        if (!_.isEmpty(string)) {
            /* eslint-disable */
            var hasLowercase = string.match(/[a-z]/g) ? true : false;
            var hasUppercase = string.match(/[A-Z]/g) ? true : false;
            var hasCharacter = hasLowercase || hasUppercase;
            var hasUpperLower = hasLowercase && hasUppercase;
            var hasNumber = string.match(/[0-9]/g) ? true : false;
            var hasSpecialChars = string.match(/[[\§\$\%\&\/\\\[\]\}\ß\?\.\-\_\"\!]/g) ? true : false;
            var hasMinLength = (string.length >= passwordLength.minimum);
            var hasBetterLength = (string.length >= passwordLength.better);
            var hasMediumLength = (string.length >= passwordLength.medium);
            var hasSafetyLength = (string.length >= passwordLength.safety);
            /* eslint-enable */

            // not long enough or either letter or number not present
            if (!(hasMinLength && hasCharacter && hasNumber)) {
                // level 1, failed
                level = 1;
            } else {
                // sufficient or better levels
                // ==> sufficient(Level 2)
                level = 2;

                // ==> good (Level 3)
                level += (hasMediumLength || hasUpperLower || hasSpecialChars ? 1 : 0);

                // ==> excellent (Level 4)
                level += (hasSafetyLength || (hasBetterLength && (hasUpperLower || hasSpecialChars)) ? 1 : 0);
            }
        }

        return level;
    }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/layout/PasswordQualityModel.js
 **/